import { FunctionComponent, MouseEvent } from 'react';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { IPasswordAdornmentProps } from './PasswordAdornment.interface';

export const PasswordAdornment: FunctionComponent<IPasswordAdornmentProps> = ({ isPasswordVisible, togglePasswordVisibility }) => {
  const handleMouseDownPassword = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  const handleMouseUpPassword = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  return (
    <InputAdornment position={'end'}>
      <IconButton
        aria-label={
          isPasswordVisible
            ? 'hide the password'
            : 'display the password'
        }
        onClick={togglePasswordVisibility}
        onMouseDown={handleMouseDownPassword}
        onMouseUp={handleMouseUpPassword}
      >
        {isPasswordVisible
          ? <VisibilityOff />
          : <Visibility />}
      </IconButton>
    </InputAdornment>
  );
};
